import type { ReactNode } from 'react'
import { StatusChip, type StatusPillTone } from './Chip'

export type { StatusPillTone }

export const StatusPill = ({
  tone = 'neutral',
  icon,
  children,
  compact = false,
  className,
}: {
  tone?: StatusPillTone
  icon?: ReactNode
  children: ReactNode
  compact?: boolean
  className?: string
}) => (
  <StatusChip
    tone={tone}
    icon={icon}
    size={compact ? 'sm' : 'md'}
    className={className}
  >
    {children}
  </StatusChip>
)
